import React from "react";
import CustomTextarea from "../../../components/Textarea/index.js";
import { IntendedUse } from "../../../entities/useCaseChat/UseCase.js";
import type { ChangeEvent } from 'react';
import { CtxGrid, CtxField } from "../../../components/UseCaseContextField/index.js";

interface IntendedUseFormProps {
    formValues: IntendedUse;
    onInputChange: (field: keyof IntendedUse, value: string) => void;
    viewOnly?: boolean
}

const IntendedUseForm: React.FC<IntendedUseFormProps> = ({
    formValues,
    onInputChange,
    viewOnly = false
}) => {
    if (viewOnly) {
        return (
            <CtxGrid>
                <CtxField label="Intended Users" value={formValues.intendedUsers} placeholder="No intended users provided" full />
                <CtxField label="Use Case Scenarios" value={formValues.useCaseScenarios} placeholder="No use case scenarios provided" full />
                <CtxField label="Accessible By" value={formValues.accessibleBy} placeholder="No accessible by provided" full />
                <CtxField label="Features" value={formValues.systemFeatures} placeholder="No features provided" full />
            </CtxGrid>
        );
    }
    return (
        <div className="space-y-6 pb-2">
            <CustomTextarea
                variant="plain"
                label="Intended Users"
                value={formValues.intendedUsers}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("intendedUsers", e)
                    } else {
                        onInputChange("intendedUsers", e.target.value)
                    }
                }}
                placeholder="Description of users"
                disabled={viewOnly}
            />
            <CustomTextarea
                variant="plain"
                label="Use case scenarios"
                value={formValues.useCaseScenarios}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("useCaseScenarios", e)
                    } else {
                        onInputChange("useCaseScenarios", e.target.value)
                    }
                }}
                placeholder=""
                disabled={viewOnly}
            />
            <CustomTextarea
                variant="plain"
                label="Accessible By"
                value={formValues.accessibleBy}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("accessibleBy", e)
                    } else {
                        onInputChange("accessibleBy", e.target.value)
                    }
                }}
                placeholder=""
                disabled={viewOnly}
            />
            <CustomTextarea
                variant="plain"
                label="Features"
                value={formValues.systemFeatures}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("systemFeatures", e)
                    } else {
                        onInputChange("systemFeatures", e.target.value)
                    }
                }}
                placeholder=""
                disabled={viewOnly}
            />
        </div>
    )
}

export default IntendedUseForm;